import type { SelectedMentorContent } from "./types";
import styles from "./MentorContentFrame.module.css";

export default function MentorContentFrame({
  selected,
  accessCode = "",
}: {
  selected: SelectedMentorContent;
  accessCode?: string;
}) {
  return (
    <div className={styles.embeddedContentFrame}>
      <iframe
        src={`${selected.url + "&accesscode=" + accessCode}&disableHeader=true`}
        title={selected.title}
        className={styles.contentIframe}
        data-cy="mentor-content-iframe"
      />
    </div>
  );
}
